var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useContext, createContext, forwardRef } from "react";
import FocusLock from "react-focus-lock";
import { IconClose } from "@wrstudios/icons";
import Portal from "../portal/Portal";
import { GlobalStyle, Container, Content, Header, Close, Body, Footer } from "./styled/modal";
var ModalContext = createContext({
    onClose: function () {
        console.warn("Please implement an onClose method.");
    }
});
// TODO: Add better accesibility to this component.
// See: https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html
function Modal(_a) {
    var _b = _a.focusLock, focusLock = _b === void 0 ? {} : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.onKeyDown, onKeyDown = _e === void 0 ? function () { } : _e, props = __rest(_a, ["focusLock", "onClose", "onClick", "onKeyDown"]);
    var containerRef = useRef(null);
    var handleClick = function (e) {
        onClick(e);
    };
    var handleKeyDown = function (e) {
        onKeyDown(e);
        if (e.key === "Escape")
            onClose();
    };
    useEffect(function () {
        document.body.classList.add("modal-open");
        return function () {
            document.body.classList.remove("modal-open");
        };
    }, []);
    return (React.createElement(Portal, null,
        React.createElement(ModalContext.Provider, { value: { onClose: onClose } },
            React.createElement(GlobalStyle, null),
            React.createElement(FocusLock, __assign({}, focusLock),
                React.createElement(Container, __assign({}, props, { ref: containerRef, onClick: handleClick, onKeyDown: handleKeyDown }))))));
}
var ModalContent = forwardRef(function (props, ref) {
    return React.createElement(Content, __assign({}, props, { ref: ref, role: "dialog", "aria-modal": "true" }));
});
function ModalHeader(props) {
    return React.createElement(Header, __assign({}, props));
}
function ModalClose(_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, _c = _a.children, children = _c === void 0 ? React.createElement(IconClose, null) : _c, props = __rest(_a, ["onClick", "children"]);
    var onClose = useContext(ModalContext).onClose;
    var handleClick = function (e) {
        e.stopPropagation();
        onClose();
        onClick(e);
    };
    return (React.createElement(Close, __assign({ type: "button" }, props, { onClick: handleClick }), children));
}
function ModalBody(props) {
    return React.createElement(Body, __assign({}, props));
}
function ModalFooter(props) {
    return React.createElement(Footer, __assign({}, props));
}
export { Modal, ModalContent, ModalHeader, ModalClose, ModalBody, ModalFooter };
